import { EntityState } from '@reduxjs/toolkit'
import { normalizeFilters } from '@user/components/Filters'
import { Draft } from 'immer'
import {
  DraftLead,
  DraftLeadPageState,
  sortOptionArray,
  defaultOrderBy,
  DraftLeadFilterSet,
} from '.'

export const setOrderBy = (
  state: Draft<EntityState<DraftLead> & DraftLeadPageState>,
  orderBy: string,
) => {
  if (state.mode === 'card' && !sortOptionArray.includes(orderBy))
    state.filterSet.orderBy = defaultOrderBy
}

export const updateFilterState = (
  state: Draft<EntityState<DraftLead> & DraftLeadPageState>,
  filterSet: DraftLeadFilterSet,
) => {
  state.page = 1
  state.shouldFetchList = true
  state.filterSet = normalizeFilters<DraftLead, DraftLeadFilterSet>(filterSet)
}
